import type { Cents, LocalizedPriceAmounts } from "@/types/pricing.type";
import type { SupportedCurrency } from "@/lib/currency";
import { SUPPORTED_CURRENCIES } from "@/lib/currency";
import localizedRaw from "@/data/localized-prices";

export type LocalizedCatalogKey = keyof typeof localizedRaw;

type DiscountBlock = {
  coupon_id: string;
};

export function buildLocalizedAmounts(
  key: LocalizedCatalogKey,
): LocalizedPriceAmounts {
  const entry = localizedRaw[key];
  const out: LocalizedPriceAmounts = {};

  // localized-prices.ts already stores integer cents (see its header note).
  for (const c of SUPPORTED_CURRENCIES) {
    out[c] = {
      originalPrice: entry.base_price[c] as Cents,
      discountedPrice: entry.discount.values[c].final as Cents,
    };
  }
  return out;
}

export function buildLocalizedStripePriceIds(
  key: LocalizedCatalogKey,
): Partial<Record<SupportedCurrency, string>> {
  const prices = localizedRaw[key].prices;
  // String form: single Stripe price with `currency_options` for every supported currency.
  if (typeof prices === "string") {
    const out: Partial<Record<SupportedCurrency, string>> = {};
    for (const c of SUPPORTED_CURRENCIES) out[c] = prices;
    return out;
  }
  return { ...prices };
}

export function getStripeDiscountIdForCatalog(
  key: LocalizedCatalogKey,
): string {
  return (localizedRaw[key].discount as DiscountBlock).coupon_id;
}

export function getLocalizedCatalogEntry(key: LocalizedCatalogKey) {
  return localizedRaw[key];
}
